import React, {useEffect, useState} from "react";
import {Field, Panel} from "../../../../layouts";
import ValidationGroup from "devextreme-react/validation-group";
import {TextBox} from "devextreme-react/text-box";
import Validator, {EmailRule, RequiredRule} from "devextreme-react/validator";
import {useEEToolContext} from "../contexts/eeToolContext";
import {useZipCodeInformation} from "../api/get-zip";
import {useStoreInformation} from "../api/get-store-information";
import {DropDownBox} from "devextreme-react";
import {useCompanyUsers} from "../api/get-company-users";
import {SelectBox} from "devextreme-react/select-box";

export function StoreInformationControl() {
    const context = useEEToolContext();
    const storeInfo = useStoreInformation(context.dealerId);
    const companyUsers = useCompanyUsers(context.dealerId);

    return (
        <Panel
            header={'Store Information'}
        >
            <ValidationGroup>
                <Field label={'Dealer Name'}>
                    <TextBox
                        className='required'
                        value={storeInfo.data.name}
                        readOnly={true}
                    />
                </Field>
                <Field label={'Store Number'}>
                    <TextBox
                        className='required'
                        value={storeInfo.data.code}
                        readOnly={true}
                    />
                </Field>
                <Field label={'Sales Assoc. Name'}>
                    <SelectBox
                        labelMode={'hidden'}
                        width={'100%'}
                        dataSource={companyUsers.data}
                        disabled={companyUsers.isLoading}
                        displayExpr="userNameToDisplay"
                        valueExpr="userName"
                        value={context.salesAssoc}
                        onValueChanged={(e) => {
                            let item = companyUsers.data.find(x=>x.userName === e.value);
                            if (item) {
                                context.setSalesAssocNumber(item.employeeNumber);
                                context.setSalesAssocPhone(item.phone);
                                context.setSalesAssocEmail(item.emailAddress);
                            }
                            context.setSalesAssoc(e.value);
                        }}
                        searchEnabled={true}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Sales Assoc. Name is required'}></RequiredRule>
                        </Validator>
                    </SelectBox>
                </Field>
                <Field label={'Sales Assoc. Nbr'}>
                    <TextBox
                        className='required'
                        value={context.salesAssocNumber}
                        readOnly={true}
                    />
                </Field>
                <Field label={'Sales Assoc. Phone'}>
                    <TextBox
                        className='required'
                        value={context.salesAssocPhone}
                        readOnly={true}
                    />
                </Field>
                <Field label={'Sales Assoc. Email'}>
                    <TextBox
                        className='required'
                        value={context.salesAssocEmail}
                        readOnly={true}
                    />
                </Field>
            </ValidationGroup>
        </Panel>)
}